import React from 'react';

import { TextProps } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { A11yWrapper } from 'components/a11y-wrapper';
import Currency from 'components/currency';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';

import { Total, TotalLabel, TotalsRow } from './styled';

export const TaxesRow: React.FC<React.PropsWithChildren<{
  taxCents: number;
  isLoading?: boolean;
  mb?: string | number;
  mt?: string | number;
  textProps?: TextProps;
}>> = ({ taxCents, isLoading, mb = '$0', mt = '$0', textProps }) => {
  const { formatMessage } = useIntl();

  return (
    <TotalsRow mb={mb} mt={mt} {...(textProps && { ...textProps })}>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <A11yWrapper>
            <TotalLabel {...(textProps && { fontSize: 'md' })}>
              {formatMessage({
                id: 'tax',
              })}
            </TotalLabel>
          </A11yWrapper>
          <Total {...(textProps && { ...textProps })}>
            <Currency textProps={textProps} amount={taxCents} testID="totalTax" />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};
